/* eslint-disable react/jsx-no-bind */
/* eslint-disable max-lines-per-function */
/**
 * @file  Events
 * @author yuanyaojia@baijia.com
 * @date 2021-04-21
 */

import React, {useEffect, useState} from 'react';
import {Button, Input, message} from 'antd';
import {getInfoById, getVideoPlayUrl} from '~/service/cms';
import Iconfont from '~/component/Iconfont';

import './index.less';

function VideoDetail(props) {
    const {match: {params: {id}}} = props;
    const [playVideoUrl, setPlayVideoUrl] = useState('');
    const [title, setTitle] = useState('');
    const [length, setLength] = useState(0);
    const [prefaceUrl, setPrefaceUrl] = useState('');

    useEffect(() => {
        window.scrollTo(0, 0);
        getInfoById({uid: id})
            .then(({data}) => {
                const {subChannelCode, content: {title, video: {length, prefaceUrl, id: videoId}}} = data;
                setTitle(title);
                setLength(length);
                setPrefaceUrl(prefaceUrl);
                if (subChannelCode === 'channel_ir_videos') {
                    getVideoPlayUrl({videoId})
                        .then(({data}) => {
                            const {playVideoUrl} = data;
                            setPlayVideoUrl(playVideoUrl);
                        })
                        .catch(() => {
                            message.info('获取视频播放链接失败');
                        });
                }
            })
            .catch(() => {
                message.error('获取视频详情失败');
            });
    }, []);

    function handleBack() {
        window.history.back();
    }

    return (
        <div className="video-detail-container">
            <div className="video-operate">
                <div className="video-back-title">
                    <div
                        className="detail-back"
                        role="button"
                        onClick={handleBack}
                        tabIndex={0}
                    >
                        <Iconfont type="iconmianbaoxiexiayiji" className="iconmianbaoxiexiayiji" />
                        <span className="detail-back-btn">Back</span>
                    </div>

                    <div className="video-detail-title">
                        {title}
                    </div>

                </div>

            </div>
            <div className="video-container">
                {/* eslint-disable-next-line jsx-a11y/media-has-caption */}
                <video
                    className="detail-video"
                    controls
                    poster={prefaceUrl}
                    src={playVideoUrl}
                />
            </div>
        </div>
    );
}

export default VideoDetail;
